var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstParchmentLogoHorizontalFullColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 319.17 57.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2b7bbc;\n      }\n\n      .cls-2 {\n        fill: #0e1721;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.04,42.82c2.25,0,3.57,1.33,3.57,3.2,0,1.27-.73,2.17-1.77,2.55,1.35.33,2.13,1.53,2.13,2.85,0,1.87-1.48,3.22-3.65,3.22h-4.14v-11.83h3.86ZM91.86,47.99c1.32,0,2.1-.78,2.1-1.88s-.82-1.85-2.17-1.85h-1.97v3.74h2.04ZM92.09,53.21c1.32,0,2.22-.73,2.22-1.89s-.72-1.93-2.15-1.93h-2.34v3.82h2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.03,57.99l2-4.24-3.45-7.14h1.8l2.5,5.54,2.4-5.54h1.68l-5.22,11.38h-1.72,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.92,54.64v-11.83h1.67v11.83h-1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.5,54.64h-1.57v-8.02h1.53v1.15c.58-1,1.53-1.38,2.47-1.38,1.92,0,2.87,1.38,2.87,3.17v5.09h-1.57v-4.82c0-1.12-.47-2.02-1.87-2.02-1.23,0-1.87.98-1.87,2.2v4.64h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.54,52.06c.1.83.73,1.5,1.87,1.5.88,0,1.37-.5,1.37-1.07,0-.5-.37-.88-1.03-1.03l-1.37-.3c-1.25-.27-2-1.12-2-2.25,0-1.37,1.28-2.54,2.85-2.54,2.2,0,2.89,1.43,3.05,2.15l-1.38.52c-.07-.42-.4-1.33-1.67-1.33-.8,0-1.33.52-1.33,1.07,0,.48.3.83.92.97l1.3.28c1.45.32,2.22,1.2,2.22,2.38s-.95,2.49-2.94,2.49c-2.2,0-3.14-1.42-3.27-2.34l1.42-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.03,46.62h1.73v1.42h-1.73v4.17c0,.73.3,1.1,1.12,1.1.2,0,.48-.03.62-.07v1.33c-.13.05-.53.15-1.07.15-1.37,0-2.24-.83-2.24-2.29v-4.4h-1.53v-1.42h.43c.87,0,1.23-.53,1.23-1.23v-1.3h1.43v2.54h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.58,48.2c-.23-.03-.47-.05-.68-.05-1.32,0-2.2.7-2.2,2.47v4.02h-1.57v-8.02h1.53v1.4c.58-1.23,1.58-1.53,2.4-1.53.22,0,.43.03.52.05v1.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.6,54.89c-1.87,0-3-1.4-3-3.22v-5.05h1.57v4.82c0,1.1.5,2.07,1.82,2.07s1.9-.83,1.9-2.05v-4.84h1.57v6.54c0,.63.05,1.2.08,1.48h-1.5c-.03-.18-.07-.63-.07-.97-.43.83-1.43,1.22-2.37,1.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M150.57,50.62c0,1.83,1.15,2.82,2.45,2.82,1.5,0,2.05-1.02,2.24-1.65l1.38.6c-.38,1.15-1.53,2.5-3.62,2.5-2.33,0-4.05-1.83-4.05-4.27s1.75-4.25,4.04-4.25c2.13,0,3.24,1.33,3.57,2.55l-1.42.6c-.2-.78-.78-1.7-2.15-1.7-1.27,0-2.43.93-2.43,2.8h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M160.17,46.62h1.73v1.42h-1.73v4.17c0,.73.3,1.1,1.12,1.1.2,0,.48-.03.62-.07v1.33c-.13.05-.53.15-1.07.15-1.37,0-2.24-.83-2.24-2.29v-4.4h-1.53v-1.42h.43c.87,0,1.23-.53,1.23-1.23v-1.3h1.43v2.54h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.19,54.89c-1.87,0-3-1.4-3-3.22v-5.05h1.57v4.82c0,1.1.5,2.07,1.82,2.07s1.9-.83,1.9-2.05v-4.84h1.57v6.54c0,.63.05,1.2.08,1.48h-1.5c-.03-.18-.07-.63-.07-.97-.43.83-1.43,1.22-2.37,1.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.55,48.2c-.23-.03-.47-.05-.68-.05-1.32,0-2.2.7-2.2,2.47v4.02h-1.57v-8.02h1.53v1.4c.58-1.23,1.58-1.53,2.4-1.53.22,0,.43.03.52.05v1.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M184.6,52.36c-.45,1.42-1.73,2.54-3.6,2.54-2.15,0-4.04-1.57-4.04-4.29,0-2.52,1.82-4.24,3.84-4.24,2.47,0,3.85,1.7,3.85,4.2,0,.2-.02.4-.03.5h-6.04c.03,1.43,1.07,2.43,2.42,2.43s1.95-.72,2.25-1.62l1.35.47h0ZM183.02,49.8c-.03-1.15-.78-2.05-2.2-2.05-1.32,0-2.12,1.02-2.19,2.05h4.39Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.35,44.15c0,2.06-1.67,3.74-3.74,3.74H10.67c-2.06,0-3.74-1.67-3.74-3.74V12.11c0-2.06,1.67-3.74,3.74-3.74h35.72V1.44H9.25C4.14,1.44,0,5.58,0,10.68v34.89c0,5.11,4.14,9.25,9.25,9.25h51.8c5.11,0,9.25-4.14,9.25-9.25v-20.24h-6.93v18.81h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.82,8.91c2.21,0,4-1.79,4-4s-1.79-4-4-4-4,1.79-4,4,1.79,4,4,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.04,8.91c2.21,0,4-1.79,4-4s-1.79-4-4-4-4,1.79-4,4,1.79,4,4,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.82,12.69c-2.21,0-4,1.79-4,4s1.79,4,4,4,4-1.79,4-4-1.79-4-4-4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 20.88,
    cy: 33.99,
    r: 8.29
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M317.15,32.45c-2.17,0-3.14-.91-3.14-3.08v-11.43h5.11v-5.21h-5.11v-7.53h-5.31v3.69c0,2.17-1.16,3.84-3.79,3.84h-1.26v.06c1.32,1.46,2.25,3.28,2.63,5.15h1.92v12.39c0,4.6,2.83,7.33,7.38,7.33,2.12,0,3.24-.4,3.59-.56v-4.85c-.25.05-1.21.2-2.02.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.88,23.05v14.28h-6.19V.77h13.56c7.01,0,11.65,4.74,11.65,11.14s-4.64,11.14-11.65,11.14c0,0-7.37,0-7.37,0ZM101.33,17.58c3.92,0,6.29-2.17,6.29-5.62s-2.37-5.72-6.29-5.72h-6.44v11.34h6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.84,38c-7.37,0-12.12-5.83-12.12-13.35s4.79-13.15,12.01-13.15c4.43,0,6.7,2.32,7.37,4.02v-3.3h5.83v20.52c0,2.06.21,4.07.26,4.59h-5.72c-.1-.57-.26-1.91-.26-3.61-1.13,2.42-3.76,4.28-7.37,4.28ZM126.51,32.84c3.92,0,6.65-3.35,6.65-8.2s-2.68-7.94-6.65-7.94-6.81,3.09-6.81,7.94,2.63,8.2,6.81,8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.26,18.15c-.67-.1-1.34-.15-1.96-.15-4.64,0-6.75,2.68-6.75,7.37v11.96h-5.98V12.22h5.83v4.02c1.19-2.73,3.97-4.33,7.27-4.33.72,0,1.34.1,1.6.15v6.08h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.01,24.75c0,5.05,3.25,7.89,7.01,7.89s5.72-2.73,6.29-4.64l5.26,1.91c-1.19,3.92-4.95,8.2-11.55,8.2-7.37,0-12.99-5.72-12.99-13.35s5.62-13.3,12.84-13.3c6.75,0,10.47,4.23,11.5,8.25l-5.36,1.96c-.57-2.22-2.27-4.69-6.08-4.69s-6.91,2.73-6.91,7.79v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192.73,37.33h-5.98V0h5.98v14.64c1.7-2.22,4.54-3.14,7.17-3.14,6.19,0,9.18,4.43,9.18,9.95v15.88h-5.98v-14.85c0-3.09-1.39-5.57-5.16-5.57-3.3,0-5.1,2.47-5.21,5.67v14.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.63,37.33V12.22h5.72v3.2c1.44-2.58,4.59-3.92,7.42-3.92,3.3,0,6.19,1.49,7.53,4.43,1.96-3.3,4.9-4.43,8.15-4.43,4.54,0,8.87,2.89,8.87,9.54v16.29h-5.77v-15.31c0-2.94-1.49-5.16-4.85-5.16-3.15,0-5.21,2.47-5.21,5.57v14.9h-5.88v-15.31c0-2.89-1.44-5.16-4.85-5.16-3.2,0-5.21,2.37-5.21,5.57v14.9h-5.93.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.32,30.16c-1.34,4.38-5.31,7.94-11.34,7.94-6.81,0-12.84-4.95-12.84-13.46,0-7.94,5.88-13.2,12.22-13.2,7.73,0,12.27,5.1,12.27,13.04,0,.98-.1,1.8-.16,1.91h-18.35c.16,3.82,3.15,6.55,6.86,6.55s5.47-1.91,6.29-4.38l5.05,1.6h0ZM272.6,22.02c-.1-2.94-2.06-5.57-6.19-5.57-3.76,0-5.93,2.89-6.13,5.57h12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.31,37.33h-5.98V12.22h5.83v3.35c1.65-2.89,4.64-4.07,7.43-4.07,6.13,0,9.07,4.43,9.07,9.95v15.88h-5.98v-14.85c0-3.09-1.39-5.57-5.16-5.57-3.4,0-5.21,2.63-5.21,5.93v14.49h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstParchmentLogoHorizontalFullColor);
export default __webpack_public_path__ + "static/media/INST-Parchment-logo-horizontal-full-color.7be6f9f22f920e1556860eae2eae74f1.svg";
export { ForwardRef as ReactComponent };